import { InfoOutlined } from "@mui/icons-material";
import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import React from "react";

const DisclaimerBanner: React.FC = () => {
  return (
    <Box>
      <Alert severity="info" icon={<InfoOutlined />} sx={{ mt: 1 }}>
        <AlertTitle sx={{ fontWeight: 600, mb: 1 }}>
          Scenario Builder uses historical data, predictive models, and assumptions to generate
          estimates.
        </AlertTitle>

        <Typography variant="body2" sx={{ mb: 1 }}>
          While every effort has been made to provide accurate and reliable insights, results are
          projections, not guarantees, and may be affected by market dynamics and unforeseen events.
        </Typography>
      </Alert>
    </Box>
  );
};

export default DisclaimerBanner;
